import React, { useRef, useState, useEffect } from 'react';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { postChangePassword, accessHistoryApi } from 'api/authApi';
import PillButton from 'components/atoms/Buttons/PillButton';
import useAuth from 'hooks/useAuth';
import { useSelector } from 'react-redux';
import { Store } from 'redux/store';
import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router-dom';
import { ChangePasswordType } from 'types/authType';
import { getLocalStorage, getSessionStorage } from 'utility/browserStorageUtil';
import useStyles from './style';

const Copyright = () => (
  <Typography variant="subtitle2" color="textSecondary" align="center">
    パスワードを忘れたときは社内システム管理者にご連絡ください。
  </Typography>
);

const ChangePassword: React.FC = () => {
  const [isSubmit, setSubmit] = useState(false);
  const { staffDetail } = useSelector((state: Store) => state.auth);
  const history = useHistory();
  const { successChangePassword } = useAuth();
  const classes = useStyles();
  const ref = useRef<any>(null);
  const { enqueueSnackbar } = useSnackbar();
  const expirationDays = getSessionStorage('expirationDays');
  const companyCode = getSessionStorage('companyCode');
  const loginCode = getLocalStorage('user');
  const staffId = getLocalStorage('staffId');

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = ref.current.elements;
    const oldPassword = form.oldPassword.value;
    const newPassword = form.newPassword.value;
    const newPasswordConfirm = form.newPasswordConfirm.value;

    // validate inputs
    if (!oldPassword || oldPassword.length === 0) {
      enqueueSnackbar('現在のパスワードを入力して下さい', { variant: 'error' });
      return;
    }

    if (!newPassword || newPassword.length === 0) {
      enqueueSnackbar('新しいパスワードを入力して下さい', { variant: 'error' });
      return;
    }

    if (!newPasswordConfirm || newPasswordConfirm.length === 0) {
      enqueueSnackbar('新しいパスワード（確認）を入力して下さい', { variant: 'error' });
      return;
    }

    if (newPassword !== newPasswordConfirm) {
      enqueueSnackbar('新しいパスワードと新しいパスワード（確認）が異なっています', { variant: 'error' });
      return;
    }

    try {
      setSubmit(true);
      const params:ChangePasswordType = {
        staffId,
        oldPassword,
        newPassword,
        newPasswordConfirm,
      };

      const response = await postChangePassword(companyCode, params);
      await successChangePassword(response);
      // redirect
      const path = `/${companyCode}`;
      redirectDashboard(path);
    } catch (error: any) {
      setSubmit(false);
      const errorResponse = error?.response?.data?.errors || error?.response?.data;
      if (errorResponse?.length && Array.isArray(errorResponse)) {
        errorResponse.forEach((err: any) => {
          enqueueSnackbar(err.defaultMessage ? err.defaultMessage : err.error, { variant: 'error' });
        });
      } else {
        enqueueSnackbar(error?.response?.data?.defaultMessage || error?.response?.error || error?.response?.data?.message || 'サーバー側でエラーが発生しました。', { variant: 'error' });
      }
    } finally {
      setSubmit(false);
    }
  };

  const redirectDashboard = (path: string = '/') => {
    const { state }: any = history.location;
    history.push(state?.from?.pathname || path);
  };

  useEffect(() => {
    // Save history access screen
    const paramsPost = { accessUrl: `${history?.location?.pathname}`, companyCode, staffId: staffDetail?.staffId || '' };
    accessHistoryApi(paramsPost);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.paper}>
        <Typography component="h1" variant="h2" className={classes.title}>
          Win-Board
        </Typography>

        {expirationDays === '-1' && (
          <>
            <Box display="flex" alignItems="center" marginBottom="0rem">
              <Typography variant="subtitle1" color="textSecondary" align="center">
                パスワードの有効期限が切れました。
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" marginBottom="2rem">
              <Typography variant="subtitle1" color="textSecondary" align="center">
                新しいパスワードに更新して下さい。
              </Typography>
            </Box>
          </>
        )}

        <Box>
          <form ref={ref} className={classes.form} noValidate={true} onSubmit={submit}>
            <Box display="flex" alignItems="left" marginBottom="1rem">
              <Typography variant="subtitle1" color="textSecondary" align="left">
                {`ID：${loginCode}`}
              </Typography>
            </Box>
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth={true}
              name="oldPassword"
              label="現在のパスワード"
              type="password"
              id="oldPassword"
              autoComplete="old-password"
            />
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth={true}
              name="newPassword"
              label="新しいパスワード"
              type="password"
              id="newPassword"
              autoComplete="new-password"
            />
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth={true}
              name="newPasswordConfirm"
              label="新しいパスワード(確認)"
              type="password"
              id="newPasswordConfirm"
              autoComplete="new-password"
            />
            <Box className={classes.submit}>
              <PillButton
                variant="contained"
                color="primary"
                disabled={isSubmit}
                type="submit"
              >
                変更する
              </PillButton>
            </Box>
          </form>
          <Box mt={2}>
            <Copyright />
          </Box>
        </Box>
      </div>
    </Container>

  );
};
export default ChangePassword;
